import { AxiosResponse } from 'axios';
import { BaseResponse } from '../models/baseResponse';
import axiosClient from './aixosClient';
import serviceType from '../constants/serviceType';

const authApi = {
    login(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'authentication_login';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    signUp(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        payload.action = 'userReg_register';
        return axiosClient.post(serviceType.USER_SERVICE, payload);
    },

    getUserInfo(): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post(serviceType.USER_SERVICE, { action: 'getUserInfo' });
    },
}

export default authApi;